import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { interval, Subscription } from 'rxjs';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-hospital-cash',
  templateUrl: './hospital-cash.component.html',
  styleUrls: ['./hospital-cash.component.css']
})
export class HospitalCashComponent implements OnInit {

  planValue = 2000;
  //for disabling div  in production
  constructor(private router: Router, private _location: Location, private serviceURLService: serviceURLService) {
     }

  ngOnInit() {
   }

   redirectToProposalForm() {
    //  var calc;
    //  if (value === 2000) {
    //   calc = 'SecureNowDCA-799';
    //  } else if (value === 3000) {
    //   calc = 'SecureNowDCA-1199'
    //  }
    //  else if(value===450){
    //    calc='SecureNowDCA-450'
    //  } else {
    //   calc = 'SecureNowDCA-1999'
    //  }
    //  window.open(environment.platformUrl + '/#/web/proposal-form/' + calc, "_blank")
    console.log('hi')
   }

  
}